import Vue from "vue";
import Vuex from "vuex";
import User from "@/models/User";
import createPersistedState from "vuex-persistedstate";


Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    user: {},
    lang: 'en',
    authenticated: false
  },
  getters: {
    isAuth: state => {
      return state.authenticated;
    },
    currentUser(state) {
      return state.user;
    },
    currentLang(state) {
      return state.lang;
    }
  },
  mutations: {
    authenticate(state) {
      state.authenticated = true;
    },
    login(state) {
      state.user = User.from(localStorage.id_token.replace("Bearer ", ""));
    },
    logout(state) {
      state.authenticated = false;
      state.user = null;
    },
    changeLang(state, lang) {
      state.lang = lang
    }
  },
  actions: {
    authenticate(context) {
      context.commit("authenticate");
    },
    login(context) {
      context.commit("login");
    },
    logout(context) {
      context.commit("logout");
    },
    changeLang(context, lang) {
      context.commit("changeLang", lang);
    }
  },
  plugins: [createPersistedState()]
});
